import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useEffect } from "react";
import "./CountryCodeMenuItem.scss";

const ENABLED_COUNTRY_CODES = ["61", "91", "64"];

const getPhoneCodeFromAgencyCountry = (agencyCountryCode: string): string => {
  switch ((agencyCountryCode || "").toUpperCase()) {
    case "AU":
      return "61";
    case "NZ":
      return "64";
    default:
      return "61";
  }
};

const CountryCodeMenuItem = ({
  formik,
  name,
  disabled,
  agencyCountryCode,
}: {
  formik: any;
  name: string;
  disabled: boolean;
  agencyCountryCode?: string | null;
}) => {
  useEffect(() => {
    if (!agencyCountryCode) return;

    if (formik?.values?.[name]) return;

    const defaultCode = getPhoneCodeFromAgencyCountry(agencyCountryCode);
    formik.setFieldValue(name, defaultCode);
  }, [agencyCountryCode]);

  return (
    <FormControl variant="outlined" className="country-code">
      <Select
        name={name}
        onChange={formik.handleChange}
        value={formik?.values?.[name] || ""}
        displayEmpty
        MenuProps={{
          disablePortal: true,
          classes: {
            paper: "selector-menu-container",
          },
        }}
        renderValue={(selected) => {
          if (!selected) return <span>+61</span>;
          return `+${selected}`;
        }}
        disabled={disabled}
      >
        {menuItem.map((item) => {
          const isEnabled = ENABLED_COUNTRY_CODES.includes(item.value);
          return (
            <MenuItem
              value={item.value}
              key={item.id}
              disabled={!isEnabled}
              className={!isEnabled ? "disabled-country-code-option" : ""}
            >
              {`+${item.value} (${item.name})`}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CountryCodeMenuItem;

export const menuItem = [
  { id: "1", value: "61", name: "Australia", countryCode: "AU" },
  { id: "8", value: "91", name: "India", countryCode: "IN" },
  { id: "2", value: "64", name: "New Zealand", countryCode: "NZ" },
  { id: "3", value: "1", name: "United States", countryCode: "US" },
  { id: "4", value: "1", name: "Canada", countryCode: "CA" },
  { id: "5", value: "44", name: "United Kingdom", countryCode: "GB" },
  { id: "6", value: "971", name: "United Arab Emirates", countryCode: "AE" },
  { id: "7", value: "966", name: "Saudi Arabia", countryCode: "SA" },
];